function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { useEffect } from 'react';
import { useRefCallback, useUpdate } from '@bydesign-ui/hooks';
import { useOptionUpdate, useSelect } from '../../../hooks/select';
import { SelectPopoverPanel } from '../components/SelectPopoverPanel';
export function useSelectPopper(options) {
  var show = options.show,
      _options$searchable = options.searchable,
      searchable = _options$searchable === void 0 ? false : _options$searchable,
      autoAlign = options.autoAlign,
      autoFocusSearch = options.autoFocusSearch,
      popoverWidth = options.popoverWidth,
      children = options.children,
      emptyRender = options.emptyRender,
      emptyContent = options.emptyContent,
      triggerId = options.triggerId,
      onSearchChange = options.onSearchChange,
      searchPlaceholder = options.searchPlaceholder;
  var select = useSelect();
  var update = useUpdate();
  var searchChange = useRefCallback(onSearchChange);
  var extraProps = select.getExtraProps();
  var size = extraProps.size || 'md';
  var clearable = extraProps.clearable || false;
  var displayInfo = select.getDisplayInfo().map(function (item) {
    return _objectSpread({}, item);
  });
  useEffect(function () {
    update();
  }, []);
  useOptionUpdate();

  var getPopover = function getPopover() {
    return React.createElement(SelectPopoverPanel, {
      autoAlign: autoAlign,
      autoFocusSearch: autoFocusSearch,
      popoverWidth: popoverWidth,
      triggerId: triggerId,
      searchable: searchable,
      emptyRender: emptyRender,
      emptyContent: emptyContent,
      onSearchChange: searchChange,
      show: show,
      searchPlaceholder: searchPlaceholder
    }, children);
  };

  return {
    getPopover: getPopover,
    displayInfo: displayInfo,
    size: size,
    clearable: clearable
  };
}